import { FunctionComponent, useEffect, useState } from "react";
import { Wallet2Icon } from "lucide-react";
import { useAppDispatch } from "../../../features/helpers";
import { WalletService } from "../../../services/WalletService";
import { openToast } from "../../../store/ToastSlice";
import { Modal, FormField } from "../../ui";

interface Props {
  open: boolean;
  onClose: () => void;
  userId: number;
  onCreated: () => void;
}

// Cadastro de carteira de destino do cliente: hash + rede (ambos string).
const ModalAddWallet: FunctionComponent<Props> = ({ open, onClose, userId, onCreated }) => {
  const dispatch = useAppDispatch();
  const [hash, setHash]       = useState("");
  const [network, setNetwork] = useState("");
  const [saving, setSaving]   = useState(false);

  useEffect(() => {
    if (!open) { setHash(""); setNetwork(""); }
  }, [open]);

  const valid = hash.trim().length > 0 && network.trim().length > 0;
  const close = () => { if (!saving) onClose(); };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!valid || saving) return;
    setSaving(true);
    try {
      await WalletService.createSimpleWallet(userId, { hash: hash.trim(), network: network.trim() });
      dispatch(openToast({ title: "Carteira", message: "Carteira adicionada com sucesso.", effect: "success" }));
      onCreated();
      onClose();
    } catch (e: any) {
      const msg = Array.isArray(e?.message) ? e.message.join(" · ") : (e?.message ?? "Falha ao adicionar a carteira.");
      dispatch(openToast({ title: "Erro ao adicionar carteira", message: msg, effect: "error" }));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={close}
      icon={Wallet2Icon}
      title="Adicionar carteira"
      subtitle="cadastre uma carteira de destino (hash + rede)"
      maxWidth={520}
      footer={
        <>
          <button type="button" className="btn-pill ghost" onClick={close} disabled={saving}>Cancelar</button>
          <button type="submit" form="modal-add-wallet-form" className="btn-pill primary" disabled={!valid || saving}>
            {saving ? "Salvando..." : "Adicionar"}
          </button>
        </>
      }
    >
      <form id="modal-add-wallet-form" onSubmit={submit}>
        <FormField label="Hash da carteira" htmlFor="w-hash">
          <input id="w-hash" value={hash} onChange={(e) => setHash(e.target.value)} placeholder="hash / endereço da carteira" autoComplete="off" />
        </FormField>
        <FormField label="Network (rede)" htmlFor="w-network">
          <input id="w-network" value={network} onChange={(e) => setNetwork(e.target.value)} placeholder="ex: Ethereum, Tron, Optimism..." autoComplete="off" />
        </FormField>
      </form>
    </Modal>
  );
};

export default ModalAddWallet;
